import { render, staticRenderFns } from "./WheelOfLife.vue?vue&type=template&id=37133f29&"
import script from "./WheelOfLife.vue?vue&type=script&lang=js&"
export * from "./WheelOfLife.vue?vue&type=script&lang=js&"
import style0 from "./WheelOfLife.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports